import { render, staticRenderFns } from "./CambiarContrasena.vue?vue&type=template&id=64352f4a&scoped=true"
import script from "./CambiarContrasena.vue?vue&type=script&lang=js"
export * from "./CambiarContrasena.vue?vue&type=script&lang=js"
import style0 from "./CambiarContrasena.vue?vue&type=style&index=0&id=64352f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64352f4a",
  null
  
)

export default component.exports